<template>
  <div class="room gas-clamp">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>舟向索夹</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">索夹</div>
          <!-- <div class="sensor2">进气口</div> -->
        </div>
        <!-- <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div> -->
        <!-- <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div> -->
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">册子岛</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">金塘岛</span>
        </div>
        <div class="cable-img">
          <div class="clip sensor1 sensor-left-1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorSN3, humidityAllowedMaxSN3) }}
              </div>
              <div :class="errorSN3" class="state-info right-pos" @dblclick="hrefToScenario('5b39453e-508f-4e0a-8a96-1fd1ebdb59c0')">
                <p>SN3传感器</p>
                <p>
                  <span
                    >{{ humiditySN3 | toFixed }}% {{ temperatureSN3 | toFixed }}°C <br />
                    {{ pressureSN3 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-left-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorSN26, humidityAllowedMaxSN26) }}
              </div>
              <div :class="errorSN26" class="state-info right-pos" @dblclick="hrefToScenario('2e5e6211-a406-4c2e-b25e-fdb701dcc5e2')">
                <p>SN26传感器</p>
                <p>
                  <span
                    >{{ humiditySN26 | toFixed }}% {{ temperatureSN26 | toFixed }}°C <br />
                    {{ pressureSN26 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorS4, humidityAllowedMaxS4) }}
              </div>
              <div :class="errorS4" class="state-info left-pos" @dblclick="hrefToScenario('256a2c81-c045-4fe1-8831-9f38156e70ce')">
                <p>S4传感器</p>
                <p>
                  <span
                    >{{ humidityS4 | toFixed }}% {{ temperatureS4 | toFixed }}°C <br />
                    {{ pressureS4 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("S39索夹", humidityTooltipErrorS39, humidityAllowedMaxS39) }} <br />
                {{ assembleTooltip_sensor("S40索夹", humidityTooltipErrorS40, humidityAllowedMaxS40) }}
              </div>
              <div :class="errorS39" class="state-info right-pos" @dblclick="hrefToScenario('36a01c28-c748-4a08-9705-c08067e9d980')">
                <p>S39 S40传感器</p>
                <p>
                  <!-- <span
                    >{{ humidityS39 | toFixed }}% {{ temperatureS39 | toFixed }}°C {{ pressureS39 | toFixed }}Pa <br />
                    {{ humidityS40 | toFixed }}% {{ temperatureS40 | toFixed }}°C {{ pressureS40 | toFixed }}Pa
                  </span> -->
                  <span
                    >{{ pressureS39 | toFixed }}Pa {{ temperatureS39 | toFixed }}°C {{ humidityS39 | toFixed }}% <br />
                    {{ pressureS40 | toFixed }}Pa {{ temperatureS40 | toFixed }}°C {{ humidityS40 | toFixed }}%
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("S41索夹", humidityTooltipErrorS41, humidityAllowedMaxS41) }} <br />
                {{ assembleTooltip_sensor("S42索夹", humidityTooltipErrorS42, humidityAllowedMaxS42) }}
              </div>
              <div :class="errorS41" class="state-info right-pos" @dblclick="hrefToScenario('a76c167e-ad37-42ff-b7e1-813b8ab751f7')">
                <p>S41 S42传感器</p>
                <p>
                  <!-- <span
                    >{{ humidityS41 | toFixed }}% {{ temperatureS41 | toFixed }}°C {{ pressureS41 | toFixed }}Pa <br />
                    {{ humidityS42 | toFixed }}% {{ temperatureS42 | toFixed }}°C {{ pressureS42 | toFixed }}Pa
                  </span> -->
                  <span
                    >{{ pressureS41 | toFixed }}Pa {{ temperatureS41 | toFixed }}°C {{ humidityS41 | toFixed }}% <br />
                    {{ pressureS42 | toFixed }}Pa {{ temperatureS42 | toFixed }}°C {{ humidityS42 | toFixed }}%
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("S43索夹", humidityTooltipErrorS43, humidityAllowedMaxS43) }} <br />
                {{ assembleTooltip_sensor("S44索夹", humidityTooltipErrorS44, humidityAllowedMaxS44) }}
              </div>
              <div :class="errorS43" class="state-info bottom-pos" @dblclick="hrefToScenario('383bae59-9376-446a-a7a1-243dac380b0c')">
                <p>S43 S44传感器</p>
                <p>
                  <span
                    >{{ humidityS43 | toFixed }}% {{ temperatureS43 | toFixed }}°C {{ pressureS43 | toFixed }}Pa <br />
                    {{ humidityS44 | toFixed }}% {{ temperatureS44 | toFixed }}°C {{ pressureS44 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("S45索夹", humidityTooltipErrorS45, humidityAllowedMaxS45) }} <br />
                {{ assembleTooltip_sensor("S46索夹", humidityTooltipErrorS46, humidityAllowedMaxS46) }}
              </div>
              <div :class="errorS45" class="state-info top-pos" @dblclick="hrefToScenario('a5d633a6-5746-4946-975a-675d68e5258b')">
                <p>S45 S46传感器</p>
                <p>
                  <span
                    >{{ humidityS45 | toFixed }}% {{ temperatureS45 | toFixed }}°C {{ pressureS45 | toFixed }}Pa <br />
                    {{ humidityS46 | toFixed }}% {{ temperatureS46 | toFixed }}°C {{ pressureS46 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-6">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("S47索夹", humidityTooltipErrorS47, humidityAllowedMaxS47) }} <br />
                {{ assembleTooltip_sensor("S48索夹", humidityTooltipErrorS48, humidityAllowedMaxS48) }}
              </div>
              <div :class="errorS47" class="state-info left-pos" @dblclick="hrefToScenario('1b34c442-3804-4405-9fb3-9bc3693a84b0')">
                <p>S47 S48传感器</p>
                <p>
                  <span
                    >{{ humidityS47 | toFixed }}% {{ temperatureS47 | toFixed }}°C {{ pressureS47 | toFixed }}Pa <br />
                    {{ humidityS48 | toFixed }}% {{ temperatureS48 | toFixed }}°C {{ pressureS48 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-7">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("S49索夹", humidityTooltipErrorS49, humidityAllowedMaxS49) }} <br />
                {{ assembleTooltip_sensor("S50索夹", humidityTooltipErrorS50, humidityAllowedMaxS50) }}
              </div>
              <div :class="errorS49" class="state-info left-pos" @dblclick="hrefToScenario('da5bb60e-d28f-4d51-907f-336f21b1d197')">
                <p>S49 S50传感器</p>
                <p>
                  <span
                    >{{ humidityS49 | toFixed }}% {{ temperatureS49 | toFixed }}°C {{ pressureS49 | toFixed }}Pa <br />
                    {{ humidityS50 | toFixed }}% {{ temperatureS50 | toFixed }}°C {{ pressureS50 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-8">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorS86, humidityAllowedMaxS86) }}
              </div>
              <div :class="errorS86" class="state-info right-pos" @dblclick="hrefToScenario('990034a7-0e76-44f5-ad8f-1277968b8ded')">
                <p>S86传感器</p>
                <p>
                  <span
                    >{{ humidityS86 | toFixed }}% {{ temperatureS86 | toFixed }}°C <br />
                    {{ pressureS86 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-right-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorSS21, humidityAllowedMaxSS21) }}
              </div>
              <div :class="errorSS21" class="state-info left-pos" @dblclick="hrefToScenario('8555a384-6c07-40dc-9de4-1bc039d50176')">
                <p>SS21传感器</p>
                <p>
                  <span
                    >{{ humiditySS21 | toFixed }}% {{ temperatureSS21 | toFixed }}°C <br />
                    {{ pressureSS21 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-right-1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorSS3, humidityAllowedMaxSS3) }}
              </div>
              <div :class="errorSS3" class="state-info left-pos" @dblclick="hrefToScenario('2dd6e23c-0cfa-442d-843c-992ca6773745')">
                <p>SS3传感器</p>
                <p>
                  <span
                    >{{ humiditySS3 | toFixed }}% {{ temperatureSS3 | toFixed }}°C <br />
                    {{ pressureSS3 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>宁向索夹</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">索夹</div>
          <!-- <div class="sensor2">进气口</div> -->
        </div>
        <!-- <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div> -->
        <!-- <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div> -->
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">册子岛</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">金塘岛</span>
        </div>
        <div class="cable-img">
          <div class="clip sensor1 sensor-left-1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorXN3, humidityAllowedMaxXN3) }}
              </div>
              <div :class="errorXN3" class="state-info right-pos" @dblclick="hrefToScenario('0fde62f3-9025-4485-afba-95cb6f6d6779')">
                <p>XN3传感器</p>
                <p>
                  <span
                    >{{ humidityXN3 | toFixed }}% {{ temperatureXN3 | toFixed }}°C <br />
                    {{ pressureXN3 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-left-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorXN26, humidityAllowedMaxXN26) }}
              </div>
              <div :class="errorXN26" class="state-info right-pos" @dblclick="hrefToScenario('7b9e0104-ef16-4fb5-88d6-a6fcc6352324')">
                <p>XN26传感器</p>
                <p>
                  <span
                    >{{ humidityXN26 | toFixed }}% {{ temperatureXN26 | toFixed }}°C <br />
                    {{ pressureXN26 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorX4, humidityAllowedMaxX4) }}
              </div>
              <div :class="errorX4" class="state-info left-pos" @dblclick="hrefToScenario('e1ee3155-dbe0-4f02-9c96-1357b9be5789')">
                <p>X4传感器</p>
                <p>
                  <span
                    >{{ humidityX4 | toFixed }}% {{ temperatureX4 | toFixed }}°C <br />
                    {{ pressureX4 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("X39索夹", humidityTooltipErrorX39, humidityAllowedMaxX39) }} <br />
                {{ assembleTooltip_sensor("X40索夹", humidityTooltipErrorX40, humidityAllowedMaxX40) }}
              </div>
              <div :class="errorX39" class="state-info right-pos" @dblclick="hrefToScenario('bfae7dbf-ed21-42f2-a3a5-52e8f7737ca6')">
                <p>X39 X40传感器</p>
                <p>
                  <!-- <span
                    >{{ humidityX39 | toFixed }}% {{ temperatureX39 | toFixed }}°C {{ pressureX39 | toFixed }}Pa <br />
                    {{ humidityX40 | toFixed }}% {{ temperatureX40 | toFixed }}°C {{ pressureX40 | toFixed }}Pa
                  </span> -->
                  <span
                    >{{ pressureX39 | toFixed }}Pa {{ temperatureX39 | toFixed }}°C {{ humidityX39 | toFixed }}% <br />
                    {{ pressureX40 | toFixed }}Pa {{ temperatureX40 | toFixed }}°C {{ humidityX40 | toFixed }}%
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("X41索夹", humidityTooltipErrorX41, humidityAllowedMaxX41) }} <br />
                {{ assembleTooltip_sensor("X42索夹", humidityTooltipErrorX42, humidityAllowedMaxX42) }}
              </div>
              <div :class="errorX41" class="state-info right-pos" @dblclick="hrefToScenario('b5dbe949-84e5-4346-bf24-d6aa15f25a5d')">
                <p>X41 X42传感器</p>
                <p>
                  <!-- <span
                    >{{ humidityX41 | toFixed }}% {{ temperatureX41 | toFixed }}°C {{ pressureX41 | toFixed }}Pa <br />
                    {{ humidityX42 | toFixed }}% {{ temperatureX42 | toFixed }}°C {{ pressureX42 | toFixed }}Pa
                  </span> -->
                  <span
                    >{{ pressureX41 | toFixed }}Pa {{ temperatureX41 | toFixed }}°C {{ humidityX41 | toFixed }}% <br />
                    {{ pressureX42 | toFixed }}Pa {{ temperatureX42 | toFixed }}°C {{ humidityX42 | toFixed }}%
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("X43索夹", humidityTooltipErrorX43, humidityAllowedMaxX43) }} <br />
                {{ assembleTooltip_sensor("X44索夹", humidityTooltipErrorX44, humidityAllowedMaxX44) }}
              </div>
              <div :class="errorX43" class="state-info bottom-pos" @dblclick="hrefToScenario('8de56c52-1181-4314-b8ff-cf5b535f4197')">
                <p>X43 X44传感器</p>
                <p>
                  <span
                    >{{ humidityX43 | toFixed }}% {{ temperatureX43 | toFixed }}°C {{ pressureX43 | toFixed }}Pa <br />
                    {{ humidityX44 | toFixed }}% {{ temperatureX44 | toFixed }}°C {{ pressureX44 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("X45索夹", humidityTooltipErrorX45, humidityAllowedMaxX45) }} <br />
                {{ assembleTooltip_sensor("X46索夹", humidityTooltipErrorX46, humidityAllowedMaxX46) }}
              </div>
              <div :class="errorX45" class="state-info top-pos" @dblclick="hrefToScenario('32e88929-c1f0-4cd5-b93a-37611629e246')">
                <p>X45 X46传感器</p>
                <p>
                  <span
                    >{{ humidityX45 | toFixed }}% {{ temperatureX45 | toFixed }}°C {{ pressureX45 | toFixed }}Pa <br />
                    {{ humidityX46 | toFixed }}% {{ temperatureX46 | toFixed }}°C {{ pressureX46 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-6">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("X47索夹", humidityTooltipErrorX47, humidityAllowedMaxX47) }} <br />
                {{ assembleTooltip_sensor("X48索夹", humidityTooltipErrorX48, humidityAllowedMaxX48) }}
              </div>
              <div :class="errorX47" class="state-info left-pos" @dblclick="hrefToScenario('0c53e97d-1cee-4241-b8d8-dcdd4859d4b7')">
                <p>X47 X48传感器</p>
                <p>
                  <span
                    >{{ humidityX47 | toFixed }}% {{ temperatureX47 | toFixed }}°C {{ pressureX47 | toFixed }}Pa <br />
                    {{ humidityX48 | toFixed }}% {{ temperatureX48 | toFixed }}°C {{ pressureX48 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-7">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("X49索夹", humidityTooltipErrorX49, humidityAllowedMaxX49) }} <br />
                {{ assembleTooltip_sensor("X50索夹", humidityTooltipErrorX50, humidityAllowedMaxX50) }}
              </div>
              <div :class="errorX49" class="state-info left-pos" @dblclick="hrefToScenario('67de6195-bcc5-4874-93e8-ccf23a33216c')">
                <p>X49 X50传感器</p>
                <p>
                  <span
                    >{{ humidityX49 | toFixed }}% {{ temperatureX49 | toFixed }}°C {{ pressureX49 | toFixed }}Pa <br />
                    {{ humidityX50 | toFixed }}% {{ temperatureX50 | toFixed }}°C {{ pressureX50 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-8">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorX86, humidityAllowedMaxX86) }}
              </div>
              <div :class="errorX86" class="state-info right-pos" @dblclick="hrefToScenario('a2e435c5-1a37-49a9-be74-b0064a949b3f')">
                <p>X86传感器</p>
                <p>
                  <span
                    >{{ humidityX86 | toFixed }}% {{ temperatureX86 | toFixed }}°C <br />
                    {{ pressureX86 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-right-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorXS21, humidityAllowedMaxXS21) }}
              </div>
              <div :class="errorXS21" class="state-info left-pos" @dblclick="hrefToScenario('0ca4a631-50de-4518-806b-d08a85bd29e1')">
                <p>XS21传感器</p>
                <p>
                  <span
                    >{{ humidityXS21 | toFixed }}% {{ temperatureXS21 | toFixed }}°C <br />
                    {{ pressureXS21 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-right-1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorXS3, humidityAllowedMaxXS3) }}
              </div>
              <div :class="errorXS3" class="state-info left-pos" @dblclick="hrefToScenario('e453f8d7-9e1b-49e2-b6ea-f81538142af4')">
                <p>XS3传感器</p>
                <p>
                  <span
                    >{{ humidityXS3 | toFixed }}% {{ temperatureXS3 | toFixed }}°C <br />
                    {{ pressureXS3 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
      
      <script>
export default {
  name: "gasClamp",
  data() {
    return {
      loading: true,
      timer: null,

      routerPrefix: "xihoumenSensor",
      bridgeId: "3aeeb5b1-f586-43c4-b03c-2e5880d2e541",

      //humidity, temperature
      humiditySN3: "--",
      humiditySN26: "--",
      humidityS4: "--",
      humidityS39: "--",
      humidityS40: "--",
      humidityS41: "--",
      humidityS42: "--",
      humidityS43: "--",
      humidityS44: "--",
      humidityS45: "--",
      humidityS46: "--",
      humidityS47: "--",
      humidityS48: "--",
      humidityS49: "--",
      humidityS50: "--",
      humidityS86: "--",
      humiditySS3: "--",
      humiditySS21: "--",
      humidityXN3: "--",
      humidityXN26: "--",
      humidityX4: "--",
      humidityX39: "--",
      humidityX40: "--",
      humidityX41: "--",
      humidityX42: "--",
      humidityX43: "--",
      humidityX44: "--",
      humidityX45: "--",
      humidityX46: "--",
      humidityX47: "--",
      humidityX48: "--",
      humidityX49: "--",
      humidityX50: "--",
      humidityX86: "--",
      humidityXS21: "--",
      humidityXS3: "--",
      humidityDehumidifierLeft: "--",
      humidityDehumidifierRight: "--",

      temperatureSN3: "--",
      temperatureSN26: "--",
      temperatureS4: "--",
      temperatureS39: "--",
      temperatureS40: "--",
      temperatureS41: "--",
      temperatureS42: "--",
      temperatureS43: "--",
      temperatureS44: "--",
      temperatureS45: "--",
      temperatureS46: "--",
      temperatureS47: "--",
      temperatureS48: "--",
      temperatureS49: "--",
      temperatureS50: "--",
      temperatureS86: "--",
      temperatureSS3: "--",
      temperatureSS21: "--",
      temperatureXN3: "--",
      temperatureXN26: "--",
      temperatureX4: "--",
      temperatureX39: "--",
      temperatureX40: "--",
      temperatureX41: "--",
      temperatureX42: "--",
      temperatureX43: "--",
      temperatureX44: "--",
      temperatureX45: "--",
      temperatureX46: "--",
      temperatureX47: "--",
      temperatureX48: "--",
      temperatureX49: "--",
      temperatureX50: "--",
      temperatureX86: "--",
      temperatureXS21: "--",
      temperatureXS3: "--",
      temperatureDehumidifierLeft: "--",
      temperatureDehumidifierRight: "--",

      pressureSN3: "--",
      pressureSN26: "--",
      pressureS4: "--",
      pressureS39: "--",
      pressureS40: "--",
      pressureS41: "--",
      pressureS42: "--",
      pressureS43: "--",
      pressureS44: "--",
      pressureS45: "--",
      pressureS46: "--",
      pressureS47: "--",
      pressureS48: "--",
      pressureS49: "--",
      pressureS50: "--",
      pressureS86: "--",
      pressureSS3: "--",
      pressureSS21: "--",
      pressureXN3: "--",
      pressureXN26: "--",
      pressureX4: "--",
      pressureX39: "--",
      pressureX40: "--",
      pressureX41: "--",
      pressureX42: "--",
      pressureX43: "--",
      pressureX44: "--",
      pressureX45: "--",
      pressureX46: "--",
      pressureX47: "--",
      pressureX48: "--",
      pressureX49: "--",
      pressureX50: "--",
      pressureX86: "--",
      pressureXS21: "--",
      pressureXS3: "--",

      //running
      runningDehumidifierLeft: "--",
      runningDehumidifierRight: "--",

      //malfunction
      malfunctionDehumidifierLeft: "--",
      malfunctionDehumidifierRight: "--",

      //error
      errorSN3: "--",
      errorSN26: "--",
      errorS4: "--",
      errorS39: "--",
      errorS40: "--",
      errorS41: "--",
      errorS42: "--",
      errorS43: "--",
      errorS44: "--",
      errorS45: "--",
      errorS46: "--",
      errorS47: "--",
      errorS48: "--",
      errorS49: "--",
      errorS50: "--",
      errorS86: "--",
      errorSS3: "--",
      errorSS21: "--",
      errorXN3: "--",
      errorXN26: "--",
      errorX4: "--",
      errorX39: "--",
      errorX40: "--",
      errorX41: "--",
      errorX42: "--",
      errorX43: "--",
      errorX44: "--",
      errorX45: "--",
      errorX46: "--",
      errorX47: "--",
      errorX48: "--",
      errorX49: "--",
      errorX50: "--",
      errorX86: "--",
      errorXS21: "--",
      errorXS3: "--",
      errorDehumidifierLeft: "--",
      errorDehumidifierRight: "--",

      //running class
      runningClassLeft: "--",
      runningClassRight: "--",

      //humidity allowed max
      humidityAllowedMaxSN3: "--",
      humidityAllowedMaxSN26: "--",
      humidityAllowedMaxS4: "--",
      humidityAllowedMaxS39: "--",
      humidityAllowedMaxS40: "--",
      humidityAllowedMaxS41: "--",
      humidityAllowedMaxS42: "--",
      humidityAllowedMaxS43: "--",
      humidityAllowedMaxS44: "--",
      humidityAllowedMaxS45: "--",
      humidityAllowedMaxS46: "--",
      humidityAllowedMaxS47: "--",
      humidityAllowedMaxS48: "--",
      humidityAllowedMaxS49: "--",
      humidityAllowedMaxS50: "--",
      humidityAllowedMaxS86: "--",
      humidityAllowedMaxSS3: "--",
      humidityAllowedMaxSS21: "--",
      humidityAllowedMaxXN3: "--",
      humidityAllowedMaxXN26: "--",
      humidityAllowedMaxX4: "--",
      humidityAllowedMaxX39: "--",
      humidityAllowedMaxX40: "--",
      humidityAllowedMaxX41: "--",
      humidityAllowedMaxX42: "--",
      humidityAllowedMaxX43: "--",
      humidityAllowedMaxX44: "--",
      humidityAllowedMaxX45: "--",
      humidityAllowedMaxX46: "--",
      humidityAllowedMaxX47: "--",
      humidityAllowedMaxX48: "--",
      humidityAllowedMaxX49: "--",
      humidityAllowedMaxX50: "--",
      humidityAllowedMaxX86: "--",
      humidityAllowedMaxXS21: "--",
      humidityAllowedMaxXS3: "--",
      humidityAllowedMaxDehumidifierLeft: "--",
      humidityAllowedMaxDehumidifierRight: "--",

      //humidity tooltip error
      humidityTooltipErrorSN3: "--",
      humidityTooltipErrorSN26: "--",
      humidityTooltipErrorS4: "--",
      humidityTooltipErrorS39: "--",
      humidityTooltipErrorS40: "--",
      humidityTooltipErrorS41: "--",
      humidityTooltipErrorS42: "--",
      humidityTooltipErrorS43: "--",
      humidityTooltipErrorS44: "--",
      humidityTooltipErrorS45: "--",
      humidityTooltipErrorS46: "--",
      humidityTooltipErrorS47: "--",
      humidityTooltipErrorS48: "--",
      humidityTooltipErrorS49: "--",
      humidityTooltipErrorS50: "--",
      humidityTooltipErrorS86: "--",
      humidityTooltipErrorSS3: "--",
      humidityTooltipErrorSS21: "--",
      humidityTooltipErrorXN3: "--",
      humidityTooltipErrorXN26: "--",
      humidityTooltipErrorX4: "--",
      humidityTooltipErrorX39: "--",
      humidityTooltipErrorX40: "--",
      humidityTooltipErrorX41: "--",
      humidityTooltipErrorX42: "--",
      humidityTooltipErrorX43: "--",
      humidityTooltipErrorX44: "--",
      humidityTooltipErrorX45: "--",
      humidityTooltipErrorX46: "--",
      humidityTooltipErrorX47: "--",
      humidityTooltipErrorX48: "--",
      humidityTooltipErrorX49: "--",
      humidityTooltipErrorX50: "--",
      humidityTooltipErrorX86: "--",
      humidityTooltipErrorXS21: "--",
      humidityTooltipErrorXS3: "--",
      humidityTooltipErrorDehumidifierLeft: "--",
      humidityTooltipErrorDehumidifierRight: "--",

      dataNameIdDict: {
        //humidity, temperature
        humiditySN3: "2f2ea776-73b3-4668-87a1-51fbea64f0c3",
        humidityXN3: "a7621a89-6b21-4d9b-9a87-a368a07038ae",
        humiditySN26: "4705be13-e03b-4825-a676-bbffdb06d706",
        humidityXN26: "e7a891e9-dd5b-4fba-af8f-74339299ee9a",
        humidityS4: "27007eb9-43b0-4125-9acb-f228a352850c",
        humidityX4: "3d350c3b-3d96-43e4-bd72-1dfaea90661c",
        humidityS39: "3954b5a5-a885-4e9e-8e56-a0eca2ec0002",
        humidityX39: "70f9b2cd-a9d1-4101-8bbf-d96c0bde567d",
        humidityS40: "1f46ccec-b1c8-45a2-9748-44286add5172",
        humidityX40: "1139f3ad-f317-4227-94ae-932ada7b9865",
        humidityS41: "2b63ff98-3131-4139-820c-2d7344bf26c0",
        humidityX41: "67a479e7-50aa-4626-8a20-7ed057920721",
        humidityS42: "9c511615-0bc7-458d-b877-177542a3923f",
        humidityX42: "2ac4ea23-ead6-4d53-bc25-0d2ca17f8ed7",
        humidityS43: "da71e83b-b94e-46f6-a9a3-a8ad9a5e3cb2",
        humidityX43: "120d4d98-e3e7-4107-9535-4f9c13cbd574",
        humidityS44: "111f7436-fc4e-4073-8ace-c9d66d6b47f8",
        humidityX44: "26074de1-4c95-44db-a50c-0160cfc89e6e",
        humiditySS3: "4a691979-87b2-4c4f-8cc6-4e204bfaf84d",
        humidityXS3: "ea1ff41a-bbc6-417d-b675-838b42abaa9b",
        humiditySS21: "79200f5a-f056-40e7-9bf1-14035491ba70",
        humidityXS21: "96ceb47a-9eb2-4917-83c2-597aa2e9d7e6",
        humidityS86: "f47d3160-3d86-4d4e-a737-684f5491c000",
        humidityX86: "5a549fe8-c3c7-4e77-bfd3-24d63a26bf09",
        humidityS49: "c72fcd1d-1cab-4fa5-a349-61cdefe2bb25",
        humidityX49: "5448ba8b-0a6e-41da-a8b1-97de59f5bd70",
        humidityS50: "8609ba1e-f244-4a12-8edd-504ec9398785",
        humidityX50: "409f0c7e-7668-41b8-a1e9-92e5ea4a7614",
        humidityS47: "92aa44a8-f41e-41b2-a5f4-f4ee0af68e66",
        humidityX47: "00a9a249-9e32-4c4e-8226-43bf33870844",
        humidityS48: "34f1e730-a099-45e3-9859-6d98394d7a7b",
        humidityX48: "14836645-7a3d-4fb1-a83b-8636e86557b0",
        humidityS45: "c250f65e-9023-4d5d-98b7-7786092a05b1",
        humidityX45: "f5d0c416-5860-43ba-abf3-d6d2e6989ac0",
        humidityS46: "463f49ef-5e47-45b4-9eb4-212ba5143e94",
        humidityX46: "39764f68-951b-4826-8441-b2ac781f9aea",
        humidityDehumidifierLeft: "ea50a278-9f53-4aaf-bf2c-bb7c576a8308",
        humidityDehumidifierRight: "a7f05749-e227-4021-b390-928934fe5fea",

        temperatureSN3: "a9233e29-225b-49b1-9270-b3a246fb7383",
        temperatureXN3: "21e67578-c558-4e63-a196-63e8f5594b33",
        temperatureSN26: "25e8a150-922c-4bd6-bc2c-d68fc2269147",
        temperatureXN26: "60abc369-1638-4e05-a51e-6ae3cefaf673",
        temperatureS4: "67d91240-32ce-4fc9-af51-5159b7acf228",
        temperatureX4: "090bc62e-8fd4-4063-be33-54074ed7dc69",
        temperatureS39: "c3a1a95b-7ec1-4ea5-8827-661f99918acf",
        temperatureX39: "e5fcc8fa-863e-4228-a7ff-23f3ff69aaae",
        temperatureS40: "4626ba79-f7a0-49cb-aa71-232f23e13a80",
        temperatureX40: "d084438d-74cd-4331-bc75-2a5b71df934a",
        temperatureS41: "ba561e64-b1df-4fde-aeda-d0b8c6e6f0f9",
        temperatureX41: "d288acc9-e3c8-4028-b308-0dee278389b8",
        temperatureS42: "8e237114-12a7-42bf-b512-da90f66f4166",
        temperatureX42: "218f7a25-b241-4e66-bb2c-23cc8f175c7e",
        temperatureS43: "ff02086c-8c97-4f59-a753-ed608ec07e4f",
        temperatureX43: "21394435-a6e9-4cc8-9ef5-aed89f0dbefc",
        temperatureS44: "dcc369b1-52a7-41c7-a272-396b424f05d0",
        temperatureX44: "27f5ea49-63c0-46b9-9337-94a68677f21a",
        temperatureSS3: "d7c5eb25-5611-4b46-9b72-20a03b657c68",
        temperatureXS3: "32a39fff-36f1-4afb-b4a0-251aa4bcbff9",
        temperatureSS21: "0bc61340-69c2-46d5-95d4-6143c9dbfcee",
        temperatureXS21: "74db4c63-6a50-427b-b662-0873c2805468",
        temperatureS86: "370f3212-441c-486d-9c6a-ce082ffc6591",
        temperatureX86: "267d9e19-2a77-4a38-ae3c-8422191d081b",
        temperatureS49: "c7f9890b-36de-4533-b288-c3f8006525e4",
        temperatureX49: "3ee74ecb-0a8f-4e54-8b36-cd7af23e7fc9",
        temperatureS50: "8b20ad95-cdeb-43e4-b4d9-da809abd3930",
        temperatureX50: "101fa5f3-efb2-4141-9dda-e61f4905a842",
        temperatureS47: "e5d8ab04-e3cc-4377-b637-d0b8d74d6649",
        temperatureX47: "c9dc5ed0-48d9-4c75-8460-400b644d1d66",
        temperatureS48: "61203f0c-82b2-4381-b545-dc97d752d211",
        temperatureX48: "0e576caf-46d6-43ac-835d-ba9a24ceaae4",
        temperatureS45: "348fc098-b0f0-4045-9e92-4cec2e6c5360",
        temperatureX45: "bd474d9a-30c2-426a-93f1-ac0d252d0325",
        temperatureS46: "dafdfa00-0806-4ef9-8703-00f80249cfb5",
        temperatureX46: "42cfb05f-14a4-4baf-8c4a-a19f3b5739c3",
        temperatureDehumidifierLeft: "cda32056-67de-4c68-ad29-6f6768497c78",
        temperatureDehumidifierRight: "c9428902-4cc1-4dc5-ba5b-bfa94381f6b3",

        pressureSN3: "d2026e6a-5ab9-41eb-bd44-9a6e73761331",
        pressureXN3: "62baaf69-8070-4838-bdf0-5b8930388473",
        pressureSN26: "f7d89436-da6e-4a84-a0b2-e4b76f3cb017",
        pressureXN26: "f93e9799-0b5e-434f-adf9-5119298b7fa3",
        pressureS4: "28f05fce-5852-44ba-9d32-3655cd969935",
        pressureX4: "5d874e0c-4889-4ee9-9e6a-6db61024bf9f",
        pressureS39: "af6abb67-0b98-4ecb-9846-b7ef1b6d414a",
        pressureX39: "f11c0b5d-57e6-44f1-94ea-8bd44d699295",
        pressureS40: "36256390-11e0-44ae-97c3-d901506b7684",
        pressureX40: "8fe495a2-52da-46aa-9e68-e6b23966d7fe",
        pressureS41: "ee937081-a982-46e5-8467-97753601fc0b",
        pressureX41: "2234b126-b921-4392-8ca3-afb095cd3471",
        pressureS42: "746469e5-74a0-469e-8eb1-7a873637829d",
        pressureX42: "50c18179-8a72-4405-871f-fb18c654d740",
        pressureS43: "bdfb8edc-2e18-451c-9e41-89f5900ba6c3",
        pressureX43: "ae8a8756-be3f-4089-97f7-8ab66844e7a9",
        pressureS44: "0f2afc7e-5f5a-4ad3-be8e-9ff0609ce9aa",
        pressureX44: "96f807fe-d57f-4649-a0bc-6aa5b7bbbcfb",
        pressureSS3: "0ad7cff6-1619-4039-8ef0-4c5ca1918cb0",
        pressureXS3: "d8fb92a9-03cd-4e56-8eef-beb86c4dda86",
        pressureSS21: "adb34fe0-de99-4621-84b6-68b975fcf376",
        pressureXS21: "7ed322fa-c79d-49f0-ba80-130e286d2581",
        pressureS86: "f345c40a-1586-49a7-b5b9-dc25eb1d27a0",
        pressureX86: "f8c77db1-cadb-456d-aac2-96a1c4127bb5",
        pressureS49: "3177c5a1-4ae9-467f-9a66-4a6b3f2d5e2b",
        pressureX49: "159ab4ba-c45b-4800-9c52-e1f4020d3c82",
        pressureS50: "a7703714-2e7d-4189-8350-7e82013bf4d6",
        pressureX50: "af46806e-8992-46c9-a5f0-cb41aef7eb3d",
        pressureS47: "fc8f51fd-6ba6-40a7-9103-a2d6071a364e",
        pressureX47: "4884cb97-3c51-4c3b-bc0b-23b329615e68",
        pressureS48: "d7f1554f-eca3-4f76-9434-44667c1ee767",
        pressureX48: "8194d4d5-95ab-4546-8891-9eb135a1caf3",
        pressureS45: "8f8e079d-8e2a-4845-bff9-3524e02584bf",
        pressureX45: "34e5c304-eb3f-490c-aba3-5c5f8842e07e",
        pressureS46: "39845cc6-01fc-46d2-8bbb-13e5daa26463",
        pressureX46: "91f602f9-1521-4a7d-9aed-182197eb128a",

        //running
        runningDehumidifierLeft: "84739471-b05f-4b34-a55a-25620974a7be",
        runningDehumidifierRight: "d5906f98-34d5-4769-b183-cab46cd67a73",

        //malfunction
        malfunctionDehumidifierLeft: "767e5ecb-427f-4d0e-be23-7959ce361072",
        malfunctionDehumidifierRight: "c1c90eb6-3e38-4345-8be7-8a3572beec32",
      },

      //humidity allowed max -> id
      allowedMaxNameIdDict: {
        humidityAllowedMaxSN3: "2f2ea776-73b3-4668-87a1-51fbea64f0c3",
        humidityAllowedMaxXN3: "a7621a89-6b21-4d9b-9a87-a368a07038ae",
        humidityAllowedMaxSN26: "4705be13-e03b-4825-a676-bbffdb06d706",
        humidityAllowedMaxXN26: "e7a891e9-dd5b-4fba-af8f-74339299ee9a",
        humidityAllowedMaxS4: "27007eb9-43b0-4125-9acb-f228a352850c",
        humidityAllowedMaxX4: "3d350c3b-3d96-43e4-bd72-1dfaea90661c",
        humidityAllowedMaxS39: "3954b5a5-a885-4e9e-8e56-a0eca2ec0002",
        humidityAllowedMaxX39: "70f9b2cd-a9d1-4101-8bbf-d96c0bde567d",
        humidityAllowedMaxS40: "1f46ccec-b1c8-45a2-9748-44286add5172",
        humidityAllowedMaxX40: "1139f3ad-f317-4227-94ae-932ada7b9865",
        humidityAllowedMaxS41: "2b63ff98-3131-4139-820c-2d7344bf26c0",
        humidityAllowedMaxX41: "67a479e7-50aa-4626-8a20-7ed057920721",
        humidityAllowedMaxS42: "9c511615-0bc7-458d-b877-177542a3923f",
        humidityAllowedMaxX42: "2ac4ea23-ead6-4d53-bc25-0d2ca17f8ed7",
        humidityAllowedMaxS43: "da71e83b-b94e-46f6-a9a3-a8ad9a5e3cb2",
        humidityAllowedMaxX43: "120d4d98-e3e7-4107-9535-4f9c13cbd574",
        humidityAllowedMaxS44: "111f7436-fc4e-4073-8ace-c9d66d6b47f8",
        humidityAllowedMaxX44: "26074de1-4c95-44db-a50c-0160cfc89e6e",
        humidityAllowedMaxSS3: "4a691979-87b2-4c4f-8cc6-4e204bfaf84d",
        humidityAllowedMaxXS3: "ea1ff41a-bbc6-417d-b675-838b42abaa9b",
        humidityAllowedMaxSS3: "79200f5a-f056-40e7-9bf1-14035491ba70",
        humidityAllowedMaxXS21: "96ceb47a-9eb2-4917-83c2-597aa2e9d7e6",
        humidityAllowedMaxS86: "f47d3160-3d86-4d4e-a737-684f5491c000",
        humidityAllowedMaxX86: "5a549fe8-c3c7-4e77-bfd3-24d63a26bf09",
        humidityAllowedMaxS49: "c72fcd1d-1cab-4fa5-a349-61cdefe2bb25",
        humidityAllowedMaxX49: "5448ba8b-0a6e-41da-a8b1-97de59f5bd70",
        humidityAllowedMaxS50: "8609ba1e-f244-4a12-8edd-504ec9398785",
        humidityAllowedMaxX50: "409f0c7e-7668-41b8-a1e9-92e5ea4a7614",
        humidityAllowedMaxS47: "92aa44a8-f41e-41b2-a5f4-f4ee0af68e66",
        humidityAllowedMaxX47: "00a9a249-9e32-4c4e-8226-43bf33870844",
        humidityAllowedMaxS48: "34f1e730-a099-45e3-9859-6d98394d7a7b",
        humidityAllowedMaxX48: "14836645-7a3d-4fb1-a83b-8636e86557b0",
        humidityAllowedMaxS45: "c250f65e-9023-4d5d-98b7-7786092a05b1",
        humidityAllowedMaxX45: "f5d0c416-5860-43ba-abf3-d6d2e6989ac0",
        humidityAllowedMaxS46: "463f49ef-5e47-45b4-9eb4-212ba5143e94",
        humidityAllowedMaxX46: "39764f68-951b-4826-8441-b2ac781f9aea",
        humidityAllowedMaxDehumidifierLeft: "ea50a278-9f53-4aaf-bf2c-bb7c576a8308",
        humidityAllowedMaxDehumidifierRight: "a7f05749-e227-4021-b390-928934fe5fea",
      },

      //humidity, temperature -> error
      dataNameErrorNameDict: {
        humiditySN3: "errorSN3",
        humiditySN26: "errorSN26",
        humidityS4: "errorS4",
        humidityS39: "errorS39",
        humidityS40: "errorS39",
        humidityS41: "errorS41",
        humidityS42: "errorS41",
        humidityS43: "errorS43",
        humidityS44: "errorS43",
        humidityS45: "errorS45",
        humidityS46: "errorS45",
        humidityS47: "errorS47",
        humidityS48: "errorS47",
        humidityS49: "errorS49",
        humidityS50: "errorS49",
        humidityS86: "errorS86",
        humiditySS3: "errorSS3",
        humiditySS21: "errorSS21",
        humidityXN3: "errorXN3",
        humidityXN26: "errorXN26",
        humidityX4: "errorX4",
        humidityX39: "errorX39",
        humidityX40: "errorX39",
        humidityX41: "errorX41",
        humidityX42: "errorX41",
        humidityX43: "errorX43",
        humidityX44: "errorX43",
        humidityX45: "errorX45",
        humidityX46: "errorX45",
        humidityX47: "errorX47",
        humidityX48: "errorX47",
        humidityX49: "errorX49",
        humidityX50: "errorX49",
        humidityX86: "errorX86",
        humidityXS21: "errorXS21",
        humidityXS3: "errorXS3",

        temperaturerSN3: "errorSN3",
        temperaturerSN26: "errorSN26",
        temperaturerS4: "errorS4",
        temperaturerS39: "errorS39",
        temperaturerS40: "errorS39",
        temperaturerS41: "errorS41",
        temperaturerS42: "errorS41",
        temperaturerS43: "errorS43",
        temperaturerS44: "errorS43",
        temperaturerS45: "errorS45",
        temperaturerS46: "errorS45",
        temperaturerS47: "errorS47",
        temperaturerS48: "errorS47",
        temperaturerS49: "errorS49",
        temperaturerS50: "errorS49",
        temperaturerS86: "errorS86",
        temperaturerSS3: "errorSS3",
        temperaturerSS21: "errorSS21",
        temperaturerXN3: "errorXN3",
        temperaturerXN26: "errorXN26",
        temperaturerX4: "errorX4",
        temperaturerX39: "errorX39",
        temperaturerX40: "errorX39",
        temperaturerX41: "errorX41",
        temperaturerX42: "errorX41",
        temperaturerX43: "errorX43",
        temperaturerX44: "errorX43",
        temperaturerX45: "errorX45",
        temperaturerX46: "errorX45",
        temperaturerX47: "errorX47",
        temperaturerX48: "errorX47",
        temperaturerX49: "errorX49",
        temperaturerX50: "errorX49",
        temperaturerX86: "errorX86",
        temperaturerXS21: "errorXS21",
        temperaturerXS3: "errorXS3",

        pressureSN3: "errorSN3",
        pressureSN26: "errorSN26",
        pressureS4: "errorS4",
        pressureS39: "errorS39",
        pressureS40: "errorS39",
        pressureS41: "errorS41",
        pressureS42: "errorS41",
        pressureS43: "errorS43",
        pressureS44: "errorS43",
        pressureS45: "errorS45",
        pressureS46: "errorS45",
        pressureS47: "errorS47",
        pressureS48: "errorS47",
        pressureS49: "errorS49",
        pressureS50: "errorS49",
        pressureS86: "errorS86",
        pressureSS3: "errorSS3",
        pressureSS21: "errorSS21",
        pressureXN3: "errorXN3",
        pressureXN26: "errorXN26",
        pressureX4: "errorX4",
        pressureX39: "errorX39",
        pressureX40: "errorX39",
        pressureX41: "errorX41",
        pressureX42: "errorX41",
        pressureX43: "errorX43",
        pressureX44: "errorX43",
        pressureX45: "errorX45",
        pressureX46: "errorX45",
        pressureX47: "errorX47",
        pressureX48: "errorX47",
        pressureX49: "errorX49",
        pressureX50: "errorX49",
        pressureX86: "errorX86",
        pressureXS21: "errorXS21",
        pressureXS3: "errorXS3",

        humidityDehumidifierLeft: "errorDehumidifierLeft",
        temperatureDehumidifierLeft: "errorDehumidifierLeft",
        humidityDehumidifierRight: "errorDehumidifierRight",
        temperatureDehumidifierRight: "errorDehumidifierRight",
      },

      //malfunction -> error
      malfunctionDataNameErrorNameDict: {
        malfunctionDehumidifierLeft: "errorDehumidifierLeft",
        malfunctionDehumidifierRight: "errorDehumidifierRight",
      },

      //humidity -> humidity tooltip error
      dataNameTooltipErrorNameDict: {
        humiditySN3: "humidityTooltipErrorSN3",
        humiditySN26: "humidityTooltipErrorSN26",
        humidityS4: "humidityTooltipErrorS4",
        humidityS39: "humidityTooltipErrorS39",
        humidityS40: "humidityTooltipErrorS40",
        humidityS41: "humidityTooltipErrorS41",
        humidityS42: "humidityTooltipErrorS42",
        humidityS43: "humidityTooltipErrorS43",
        humidityS44: "humidityTooltipErrorS44",
        humidityS45: "humidityTooltipErrorS45",
        humidityS46: "humidityTooltipErrorS46",
        humidityS47: "humidityTooltipErrorS47",
        humidityS48: "humidityTooltipErrorS48",
        humidityS49: "humidityTooltipErrorS49",
        humidityS50: "humidityTooltipErrorS50",
        humidityS86: "humidityTooltipErrorS86",
        humiditySS3: "humidityTooltipErrorSS3",
        humiditySS21: "humidityTooltipErrorSS21",
        humidityXN3: "humidityTooltipErrorXN3",
        humidityXN26: "humidityTooltipErrorXN26",
        humidityX4: "humidityTooltipErrorX4",
        humidityX39: "humidityTooltipErrorX39",
        humidityX40: "humidityTooltipErrorX40",
        humidityX41: "humidityTooltipErrorX41",
        humidityX42: "humidityTooltipErrorX42",
        humidityX43: "humidityTooltipErrorX43",
        humidityX44: "humidityTooltipErrorX44",
        humidityX45: "humidityTooltipErrorX45",
        humidityX46: "humidityTooltipErrorX46",
        humidityX47: "humidityTooltipErrorX47",
        humidityX48: "humidityTooltipErrorX48",
        humidityX49: "humidityTooltipErrorX49",
        humidityX50: "humidityTooltipErrorX50",
        humidityX86: "humidityTooltipErrorX86",
        humidityXS21: "humidityTooltipErrorXS21",
        humidityXS3: "humidityTooltipErrorXS3",
        humidityDehumidifierLeft: "humidityTooltipErrorDehumidifierLeft",
        humidityDehumidifierRight: "humidityTooltipErrorDehumidifierRight",
      },

      //running -> running class
      dataNameRunningClassNameDict: {
        runningDehumidifierLeft: "runningClassLeft",
        runningDehumidifierRight: "runningClassRight",
      },

      //station id list
      stationIdList: [
        "d252c9a1-14b3-44d7-a34c-62553f7efdb2",
        "88faa711-2ee3-4ca0-8759-8a26565472d3",
        "4ade1b4b-0eda-459a-88db-95cdf09387ff",
        "9658719c-40d9-4c73-bc71-f0fe706733f9",
      ],
    };
  },
  filters: {
    toFixed(val) {
      if (val === 0) return "0.0";
      if (!Number(val)) return "--";
      return Number(val).toFixed(1);
    },
  },
  mounted() {
    this.getAllowedMax();
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    refreshData() {
      this.loading = true;
      this.getData();
    },
    getData() {
      this.resetError();
      let stationRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationRequestList.push(this.$http.get(`/deviceData/Station?stationId=${stationId}`));
      });

      this.$http.all(stationRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setDataAndError(res.data);
            this.loading = false;
          });
        })
      );
    },
    setDataAndError(stationData) {
      //device id not set (device id = 'GUID') = no data
      stationData["GUID"] = {
        dataId: null,
        deviceId: "GUID",
        value: null,
        createdDate: "0001-01-01T00:00:00",
        dataDate: "0001-01-01T00:00:00",
        dataType: "VALUE",
        errorLevel: "Warning",
      };

      for (let dataName in this.dataNameIdDict) {
        const dataId = this.dataNameIdDict[dataName];
        if (stationData[dataId] !== undefined) {
          this[dataName] = stationData[dataId].value;

          // //set value for running sign
          // if (this.dataNameRunningTooltipNameDict[dataName] !== undefined && this.dataNameRunningClassNameDict[dataName] != undefined) {
          //   let runningData = stationData[dataId];
          //   if (runningData.value === 1) {
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "运行";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "running";
          //   } else if (runningData.errorLevel !== "Warning") {
          //     //empty data value also === 0
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "停止";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
          //   }
          // }

          console.log("set data and error: " + dataName);

          //set value for running sign
          if (this.dataNameRunningClassNameDict[dataName] != undefined) {
            let runningData = stationData[dataId];
            if (runningData.value === 1) {
              this[this.dataNameRunningClassNameDict[dataName]] = "running";
            } else if (runningData.errorLevel !== "Warning") {
              //empty data value also === 0
              this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
            }
          }

          if (this.dataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameErrorNameDict[dataName];
            this[errorName] = this.getErrorLevelFromMultipleDevice(this[errorName], stationData[dataId].errorLevel);
          }

          if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameTooltipErrorNameDict[dataName];
            this[errorName] = stationData[dataId].errorLevel;
          }

          if (this.malfunctionDataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.malfunctionDataNameErrorNameDict[dataName];
            if (this[errorName] === "" && stationData[dataId].value && stationData[dataId].value > 0) {
              this[errorName] = "Error";
            }
          }
        }
      }
    },
    getAllowedMax() {
      let stationMetaRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationMetaRequestList.push(this.$http.get(`/bridge/StationInfo?stationId=${stationId}`));
      });

      this.$http.all(stationMetaRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setAllowedMax(res.data);
          });
        })
      );
    },
    setAllowedMax(stationData) {
      let deviceIdDevicedict = {};
      if (stationData.deviceList) {
        stationData.deviceList.forEach((item) => {
          deviceIdDevicedict[item.deviceId] = item;
        });
      }

      for (let allowedMaxName in this.allowedMaxNameIdDict) {
        const dataId = this.allowedMaxNameIdDict[allowedMaxName];
        if (deviceIdDevicedict[dataId] !== undefined) {
          let device = deviceIdDevicedict[dataId];
          this[allowedMaxName] = device.allowedMax;
        }
      }
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
    resetError() {
      for (let dataName in this.dataNameIdDict) {
        if (this.dataNameErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameErrorNameDict[dataName];
          this[errorName] = "";
        }

        if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameTooltipErrorNameDict[dataName];
          this[errorName] = "";
        }
      }
    },
    assembleTooltip_sensor(name, errorLevel, allowedMax) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if (
        (errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") &&
        allowedMax !== undefined &&
        allowedMax !== null &&
        !isNaN(parseInt(allowedMax))
      ) {
        if (allowedMax === 0) {
          result += "(无限制)";
        } else {
          result += "(<" + allowedMax + "%RH)";
        }
      }

      return result;
    },
    assembleTooltip_dehumidifier(name, errorLevel, allowedMax, runningFlag, errorFlag) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      if (errorLevel.toLowerCase() !== "warning") {
        if (runningFlag > 0) {
          result += ", 除湿机运行";
        } else if (runningFlag === 0) {
          result += ", 除湿机停止";
        }
      }

      if (errorFlag > 0) {
        result += ", 故障报警";
      }

      return result;
    },
    hrefToScenario(id){
      if(!id || id===''){
        return;
      }

      this.$router.push("/"+this.routerPrefix+"/dataHistory?bridgeId="+this.bridgeId+"&scenarioId="+id);
    },
    hrefToStation(id){
      if(!id || id === ''){
        return;
      }

      this.$router.push("/"+this.routerPrefix+id);
    },
  },
};
</script>
      
      <style lang="scss" scoped>
@keyframes breathee-warning {
  0% {
    border-color: rgba(255, 255, 0, 0.3);
  }
  100% {
    border-color: #ffff00;
    // background: rgba(255, 255, 255, 0.7);
  }
}
@keyframes breathee-error {
  0% {
    border-color: rgba(255, 0, 0, 0.3);
  }
  100% {
    border-color: #ff0000;
    // background: rgba(255, 255, 255, 0.7);
  }
}

.tooltip-slot {
  line-height: 1.4;
}

.gas-clamp {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: calc(100% - 20px) !important;
  min-height: 630px !important;

  .main-cable {
    width: 100%;
    height: 48%;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;

    .cable-title {
      width: 50px;
      text-align: center;
      display: flex;
      background-color: #fff;
      justify-content: center;
      align-items: center;

      h2 {
        padding: 0 10px;
        font-weight: 400;
        font-size: 24px;
        line-height: 35px;
        font-weight: bold;
        color: #515151;
      }
    }

    .cable-main {
      position: relative;
      min-width: 1200px;
      width: calc(100% - 50px);
      background: linear-gradient(#ceeaf0, #e9f1ef);
      display: flex;
      justify-content: center;
      align-items: center;

      .legend {
        position: absolute;
        left: 75px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .sensor1:after {
          background: #c7798b;
        }
        .sensor2:after {
          background: #3376c7;
        }
      }
      .legend-right {
        position: absolute;
        right: 70px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .default:after {
          background: #ffff00;
        }
        .running:after {
          background: #67dd34;
        }
        .stopped:after {
          background: #a0a0a0;
        }
      }
      .legend-station {
        position: absolute;
        left: 73px;
        top: 108px;

        i {
          font-size: 24px;
          color: #ed6a5a;
        }
        span {
          padding-left: 8px;
          bottom: 3px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
        }
      }

      .dir {
        position: absolute;
        top: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #2a387a;
        i {
          font-size: 30px;
        }
        .dir-text {
          font-size: 20px;
        }
      }
      .left-dir {
        left: 250px;
      }
      .right-dir {
        flex-direction: row-reverse;
        right: 250px;
      }
      .cable-img {
        position: relative;
        z-index: 0;
        width: 1200px;
        height: 300px;
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url("../../assets/image/xihoumen/bridgeLine.png");
        background-position-y: 100%;

        .station-block {
          position: absolute;
          color: #ed6a5a;
          font-size: 24px;
          text-decoration: none;
        }

        .station-block-left {
          top: 122px;
          left: 173px;
        }

        .station-block-middle {
          top: 122px;
          left: 582px;
        }

        .station-block-right {
          top: 122px;
          left: 990px;
        }

        .stati {
          position: absolute;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
            background: #ed6a5a;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            text-decoration: none;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            background-color: rgba(246, 250, 255, 0.9);
            &:before {
              background-color: #ed6a5a;
            }
            & > p {
              margin: 0;
              white-space: nowrap;
              white-space: nowrap;
              display: flex;
              justify-content: space-between;
              align-items: baseline;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &.bottom-pos-sta:before {
              left: 50%;
              top: 95%;
              transform: translate(0%, 0%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }

            .valve-sign {
              margin-top: auto;
              margin-bottom: auto;
              width: 12px;
              height: 12px;
              background-color: #ffff00;
              animation: breathee-valve-sign-default 1500ms infinite alternate ease-in-out;
              border-radius: 10px;
              margin-left: 12px;

              &.running {
                background-color: #67dd34;
                animation: none;
              }
              &.stopped {
                background-color: #a0a0a0;
                animation: none;
              }
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
        }

        .clip {
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 8px;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            & > p {
              margin: 0;
              white-space: nowrap;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &.bottom-pos:before {
              left: 50%;
              top: 93%;
              transform: translate(0%, 0%);
            }
            &.top-pos:before {
              left: 50%;
              top: -5px;
              transform: translate(0%, 0%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
          &.sensor1 {
            background: #c7798b;
            &:after,
            &:before {
              background: #c7798b;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #c7798b;
              }
            }
          }
          &.sensor2 {
            background: #3376c7;
            &:after,
            &:before {
              background: #3376c7;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #3376c7;
              }
            }
          }
        }

        .sensor-left-1 {
          top: 180px;
          left: 90px;
          &::before {
            bottom: 22px;
            left: -23px;
            width: 40px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 39px;
            left: -27px;
          }
          .state-info {
            right: 40px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sensor-left-2 {
          top: 125px;
          left: 255px;
          &::before {
            bottom: 22px;
            left: -23px;
            width: 40px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 39px;
            left: -27px;
          }
          .state-info {
            right: 40px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sensor-middle-1 {
          top: 125px;
          left: 320px;
          &::before {
            bottom: 45px;
            left: -30px;
            width: 90px;
            transform: rotate(100deg);
          }
          &::after {
            bottom: 89px;
            left: 23px;
          }
          .state-info {
            right: -150px;
            top: -74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sensor-middle-2 {
          top: 173px;
          left: 545px;
          &::before {
            bottom: -25px;
            left: -32px;
            width: 70px;
            transform: rotate(280deg);
          }
          &::after {
            bottom: -59px;
            left: -18px;
          }
          .state-info {
            right: 33px;
            top: 74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 165px;
          }
        }

        .sensor-middle-3 {
          top: 175px;
          left: 575px;
          &::before {
            bottom: 34px;
            left: -31px;
            width: 50px;
            transform: rotate(65deg);
          }
          &::after {
            bottom: 57px;
            left: -31px;
          }
          .state-info {
            right: 45px;
            top: -41px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 165px;
          }
        }

        .sensor-middle-4 {
          top: 180px;
          left: 626px;
          &::before {
            bottom: 40px;
            left: -22px;
            width: 60px;
            transform: rotate(90deg);
          }
          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }
          .state-info {
            right: -70px;
            top: -90px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 165px;
          }
        }

        .sensor-middle-5 {
          top: 180px;
          left: 626px;
          &::before {
            bottom: -5px;
            left: -9px;
            width: 35px;
            transform: rotate(90deg);
          }
          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }
          .state-info {
            right: -70px;
            top: 70px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 165px;
          }
        }

        .sensor-middle-6 {
          top: 175px;
          left: 675px;
          &::before {
            bottom: 34px;
            left: -6px;
            width: 50px;
            transform: rotate(110deg);
          }
          &::after {
            bottom: 57px;
            left: 27px;
          }
          .state-info {
            right: -188px;
            top: -41px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 165px;
          }
        }

        .sensor-middle-7 {
          top: 173px;
          left: 702px;
          &::before {
            bottom: -25px;
            left: -20px;
            width: 70px;
            transform: rotate(260deg);
          }
          &::after {
            bottom: -59px;
            left: 21px;
          }
          .state-info {
            right: -182px;
            top: 74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 165px;
          }
        }

        .sensor-middle-8 {
          top: 125px;
          left: 918px;
          &::before {
            bottom: 45px;
            left: -45px;
            width: 90px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 89px;
            left: -23px;
          }
          .state-info {
            right: 38px;
            top: -74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sensor-right-2 {
          top: 125px;
          left: 983px;
          &::before {
            bottom: 22px;
            left: -3px;
            width: 40px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 39px;
            left: 27px;
          }
          .state-info {
            right: -150px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sensor-right-1 {
          top: 180px;
          left: 1123px;
          &::before {
            bottom: 22px;
            left: -3px;
            width: 40px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 39px;
            left: 27px;
          }
          .state-info {
            right: -150px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .station-block-left {
          top: 108px;
          left: 282px;
        }

        .sta-left {
          top: 108px;
          left: 282px;
          &::before {
            bottom: 15px;
            left: -18px;
            width: 60px;
            transform: rotate(90deg);
          }
          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }
          .state-info {
            right: -70px;
            top: -70px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 115px;
          }
        }

        .station-block-right {
          top: 108px;
          left: 945px;
        }

        .sta-right {
          top: 108px;
          left: 945px;
          &::before {
            bottom: 15px;
            left: -18px;
            width: 60px;
            transform: rotate(90deg);
          }
          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }
          .state-info {
            right: -70px;
            top: -70px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 115px;
          }
        }
      }
    }
  }
}
</style>